"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _excluded = ["className", "progress", "children", "disabled"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Button/index.js";
var defaultProps = {};
function Button(_ref) {
  var className = _ref.className,
    progress = _ref.progress,
    children = _ref.children,
    disabled = _ref.disabled,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var defaultStyle = {
    cursor: progress ? "wait" : ""
  };
  var attributes = (0, _objectSpread2["default"])({
    className: (0, _classNames["default"])(className, 'btn btn-primary'),
    style: (0, _objectSpread2["default"])({}, defaultStyle)
  }, props);
  return /*#__PURE__*/_react["default"].createElement("button", Object.assign({}, attributes, {
    disabled: progress || disabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 9
    }
  }), progress && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    className: "me-2",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 26
    }
  }), children);
}
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;